import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const updateContactItem = async ({ primaryKey, itemId, tableName, fieldName, newValue }) => {
  console.log('[updateContactItem] called with item: ', { primaryKey, itemId, tableName, fieldName, newValue })
  // const url = `${baseUrl}/aws/tasks/updateitems`
  const url = `${baseUrl}/aws/update-contact`
  try {
    const response = await axios.put(url, { primaryKey, itemId, tableName, fieldName, newValue })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update item:', error)
    throw error
  }
}

export const useUpdateContactItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: updateContactItem,
    onSuccess: (data, variables) => {
      console.log('[useUpdateContactItem] Updated item data:', data, 'VARIABLES: ', variables)
      queryClient.invalidateQueries({ queryKey: ['contact', variables.itemId] })
    },
    onError: error => {
      console.error('[useUpdateContactItem] Error updating item:', error)
    },
  })
  return mutation
}
